import './highlight-animation.scss';

import { components } from 'gridstrap/lib/gs-components';
import { GSHighlightAnimation } from './highlight-animation';

components.register({
	selector: '.gs-HighlightAnimation',
	controller: GSHighlightAnimation
});
